import { render } from "./RanksChartForNeedsAndMetrics.vue?vue&type=template&id=121827da"
import script from "./RanksChartForNeedsAndMetrics.vue?vue&type=script&lang=js"
export * from "./RanksChartForNeedsAndMetrics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__